import { useEffect, useMemo, useState } from "react";
import useAdvisorClientsV2 from "../../Entity/hooks/useAdvisorClientsV2";
import useGetFartherEmployees from "../../Entity/hooks/useFartherEmployees";
import useGetServiceTeams from "../../Entity/hooks/useGetServiceTeams";
import searchParameters from "../requests/searchParameters";
import { isEnumValue } from "../utils/guards";
import useGetTaskTypes from "./useGetTaskTypes";
const statusAndPriorityParams = {
    fields: {
        taskPriority: {
            type: "StaticEnum",
            kinds: ["TaskPriority"],
        },
        taskStatus: {
            type: "StaticEnum",
            kinds: ["TaskStatus"],
        },
    },
};
// TODO: think about returning a partial data in case when one of the queries fails
const useGetTaskResources = (auth) => {
    const advisorId = auth?.advisorId ?? null;
    const [isLoading, setIsLoading] = useState(false);
    const [error, setError] = useState();
    const [searchResult, setSearchResult] = useState(null);
    const advisorsQuery = useGetFartherEmployees("All", auth);
    const clientsQuery = useAdvisorClientsV2(advisorId, auth);
    const serviceTeamsQuery = useGetServiceTeams(auth);
    const taskTypesQuery = useGetTaskTypes(auth);
    useEffect(() => {
        const callSearchParameters = async () => {
            if (auth) {
                try {
                    setIsLoading(true);
                    const response = await searchParameters(statusAndPriorityParams, auth);
                    setSearchResult(response.data);
                }
                catch (error) {
                    setError(error);
                }
                finally {
                    setIsLoading(false);
                }
            }
        };
        callSearchParameters();
    }, [auth]);
    const resourceMaps = useMemo(() => {
        const advisors = advisorsQuery.data?.advisors ?? [];
        const clients = clientsQuery.data?.clients ?? [];
        const serviceTeams = serviceTeamsQuery.data ?? [];
        const taskTypes = taskTypesQuery.data?.data ?? [];
        const taskStatuses = (searchResult?.["taskStatus"]?.values ?? []).filter(isEnumValue);
        const taskPriorities = (searchResult?.["taskPriority"]?.values ?? []).filter(isEnumValue);
        return {
            advisorsMap: new Map(advisors.map((advisor) => [advisor.advisorId, advisor])),
            clientsMap: new Map(clients.map((client) => [client.clientId, client])),
            serviceTeamsMap: new Map(serviceTeams.map((team) => [team.serviceTeamId, team])),
            taskTypesMap: new Map(taskTypes.map((type) => [String(type.typeId), type])),
            taskStatusesMap: new Map(taskStatuses.map((status) => [status.id, status])),
            taskPrioritiesMap: new Map(taskPriorities.map((priority) => [priority.id, priority])),
        };
    }, [
        advisorsQuery.data,
        clientsQuery.data,
        serviceTeamsQuery.data,
        taskTypesQuery.data,
        searchResult,
    ]);
    if (isLoading ||
        advisorsQuery.isLoading ||
        clientsQuery.isLoading ||
        serviceTeamsQuery.isLoading ||
        taskTypesQuery.isLoading) {
        return {
            data: undefined,
            isLoading: true,
            hasError: false,
        };
    }
    if (advisorsQuery.hasError) {
        return {
            data: undefined,
            isLoading: false,
            hasError: true,
            error: advisorsQuery.error,
        };
    }
    if (clientsQuery.hasError) {
        return {
            data: undefined,
            isLoading: false,
            hasError: true,
            error: clientsQuery.error,
        };
    }
    if (serviceTeamsQuery.hasError) {
        return {
            data: undefined,
            isLoading: false,
            hasError: true,
            error: serviceTeamsQuery.error,
        };
    }
    if (taskTypesQuery.hasError) {
        return {
            data: undefined,
            isLoading: false,
            hasError: true,
            error: taskTypesQuery.error,
        };
    }
    // eslint-disable-next-line @typescript-eslint/strict-boolean-expressions
    if (error) {
        return {
            data: undefined,
            isLoading: false,
            hasError: true,
            error,
        };
    }
    return {
        data: resourceMaps,
        isLoading: false,
        hasError: false,
    };
};
export default useGetTaskResources;
//# sourceMappingURL=useGetTaskResources.js.map